import SuperJSON from "superjson";
import Id from "../types/Id";

export default class RuleId extends Id<"rule"> {}

SuperJSON.registerClass(RuleId, { identifier: "RuleId" });
